import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import "../../styles/login/login-page.css";
import { wtflogo } from "../../exports/Images";
import Loader from "../ui/Loader";
import { useCreateFetch, useUpdateFetch } from "../../data/Queries";
import { forgetPassword, resetPassword } from "../../data/ApiEndpoints";
import {
  forgetPasswordSchema,
  resetPasswordSchema,
} from "../../schema/authSchema";
import { FORGET_PASSWORD_STEPS } from "../../data/Constants";

const LoginPage = ({ formik, isLoadingLogin }) => {
  const [isForgetPassword, setIsForgetPassword] = useState(false);
  const [forgetPasswordStep, setForgetPasswordStep] = useState(
    FORGET_PASSWORD_STEPS.EMAIL
  );
  const [userId, setUserId] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const { mutateAsync: forgetPasswordUser, isLoading: isLoadingForget } =
    useCreateFetch({
      key: "forgetPassword",
      token: "",
      url: forgetPassword,
    });

  const { mutateAsync: resetPasswordUser, isLoading: isLoadingReset } =
    useUpdateFetch({
      key: "resetPassword",
      token: "",
      url: resetPassword,
    });

  const handleForgetPasswordEmailSubmit = async (values) => {
    try {
      const response = await forgetPasswordUser({
        type: "email",
        username: values.email,
        sms: 1,
      });
      if (response?.status === true) {
        setUserId(response?.data?.user_id);
        setForgetPasswordStep(FORGET_PASSWORD_STEPS.RESET);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Forget password error:", error);
    }
  };

  const handleResetPasswordSubmit = async (values) => {
    const data = {
      user_id: userId,
      reset_otp: values.otp,
      password: values.newPassword,
    };

    try {
      const response = await resetPasswordUser({ data });
      if (response.status) {
        setForgetPasswordStep(FORGET_PASSWORD_STEPS.COMPLETE);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Reset password error:", error);
    }
  };

  const forgetPasswordFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgetPasswordSchema,
    onSubmit: handleForgetPasswordEmailSubmit,
  });

  const resetPasswordFormik = useFormik({
    initialValues: {
      otp: "",
      newPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: handleResetPasswordSubmit,
  });

  const clearForm = () => {
    formik.resetForm();
    resetPasswordFormik.resetForm();
    forgetPasswordFormik.resetForm();
  };

  const handleResetComplete = () => {
    setForgetPasswordStep(FORGET_PASSWORD_STEPS.EMAIL);
    setIsForgetPassword(false);
    clearForm();
  };

  const handleForgetPassword = () => {
    setIsForgetPassword(true);
    formik.resetForm();
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const RenderLoginFields = () => (
    <>
      <div className="login_field">
        <label>Email</label>
        <input
          id="username"
          placeholder="Email"
          value={formik?.values?.username}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="input-k"
        />
        {formik?.touched?.username && formik?.errors?.username && (
          <span className="error-message">{formik?.errors?.username}</span>
        )}
      </div>

      <div className="login_field relative_LoginField">
        <label>Password</label>
        <input
          id="password"
          placeholder="Password"
          value={formik?.values?.password}
          className="input-k"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type={isPasswordVisible ? "text" : "password"}
        />
        <div className="toggle-password" onClick={togglePasswordVisibility}>
          {isPasswordVisible ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16"
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-slash-fill"
              viewBox="0 0 16 16"
            >
              <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
              <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
            </svg>
          )}
        </div>
        {formik?.touched?.password && formik?.errors?.password && (
          <span className="error-message">{formik?.errors?.password}</span>
        )}
      </div>
      <p className="login__forget" onClick={handleForgetPassword}>
        Forgot Password?
      </p>
    </>
  );

  const RenderForgetPasswordStep1 = () => (
    <>
      <div className="login_field">
        <label>Enter your email</label>
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={forgetPasswordFormik.values.email}
          onChange={forgetPasswordFormik.handleChange}
          className="input-k"
        />
        {forgetPasswordFormik?.touched?.email &&
          forgetPasswordFormik?.errors?.email && (
            <span className="error-message">
              {forgetPasswordFormik?.errors?.email}
            </span>
          )}
      </div>
      <button
        className="login__buttonRed"
        disabled={isLoadingForget}
        // onClick={handleForgetPasswordEmailSubmit}
        onClick={forgetPasswordFormik.handleSubmit}
      >
        {isLoadingForget ? <Loader color="#ffffff" /> : "Continue"}
      </button>
      <div style={{ paddingBottom: "10px" }} />
      <button className="login__buttonBlack" onClick={handleResetComplete}>
        Cancel
      </button>
    </>
  );

  const RenderForgetPasswordStep2 = () => (
    <>
      <div className="login_field">
        <label>Enter OTP</label>
        <input
          name="otp"
          type="text"
          placeholder="OTP"
          value={resetPasswordFormik.values.otp}
          onChange={resetPasswordFormik.handleChange}
          className="input-k"
        />
        {resetPasswordFormik?.touched?.otp &&
          resetPasswordFormik?.errors?.otp && (
            <span className="error-message">
              {resetPasswordFormik?.errors?.otp}
            </span>
          )}
      </div>
      <div className="login_field">
        <label>New Password</label>
        <input
          name="newPassword"
          type="password"
          placeholder="New Password"
          value={resetPasswordFormik.values.newPassword}
          onChange={resetPasswordFormik.handleChange}
          className="input-k"
        />
        {resetPasswordFormik?.touched?.newPassword &&
          resetPasswordFormik?.errors?.newPassword && (
            <span className="error-message">
              {resetPasswordFormik?.errors?.newPassword}
            </span>
          )}
      </div>
      <button
        className="login__buttonRed"
        onClick={resetPasswordFormik.handleSubmit}
        disabled={isLoadingReset}
      >
        {isLoadingReset ? <Loader color="#ffffff" /> : "Submit"}
      </button>
      <div style={{ paddingBottom: "10px" }} />
      <button className="login__buttonBlack" onClick={handleResetComplete}>
        Cancel
      </button>
    </>
  );

  const RenderForgetPasswordStep3 = () => (
    <>
      <p style={{ color: "#4BB543" }}>Password reset successfully!</p>
      <button className="login__buttonRed" onClick={handleResetComplete}>
        Back to Login
      </button>
    </>
  );

  return (
    <div className="login">
      <form className="login__Wrapper" onSubmit={formik.handleSubmit}>
        <div className="login_Card">
          <img src={wtflogo} alt="wtf-logo" />

          <div className="login__text">
            <h4>{isForgetPassword ? "Reset Password" : "Sign In"}</h4>
            <p>
              {isForgetPassword
                ? "Follow the steps to reset your password"
                : "Login to your account"}
            </p>
          </div>

          <div className="login__fields">
            {!isForgetPassword && RenderLoginFields()}
            {isForgetPassword &&
              forgetPasswordStep === FORGET_PASSWORD_STEPS.EMAIL &&
              RenderForgetPasswordStep1()}
            {isForgetPassword &&
              forgetPasswordStep === FORGET_PASSWORD_STEPS.RESET &&
              RenderForgetPasswordStep2()}
            {isForgetPassword &&
              forgetPasswordStep === FORGET_PASSWORD_STEPS.COMPLETE &&
              RenderForgetPasswordStep3()}
          </div>

          {!isForgetPassword && (
            <button
              disabled={isLoadingLogin}
              className="login__buttonRed"
              type="submit"
            >
              {isLoadingLogin ? <Loader color="#ffffff" /> : "Log in"}
            </button>
          )}

          {/* <Link to="/open-access" className="bottom__PageLink">
            Login to open access page
          </Link> */}
        </div>
      </form>
    </div>
  );
};

export default LoginPage;